module.exports = __webpack_public_path__ + "assets/img/QRlogoA.e30fe757a312eaf67d6000e4370ab204.svg";